import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { contaApi } from '../../services/api';
import { Loading, EmptyState } from '../../components/ui';
import { CartaoPedido } from './CartaoPedido';
import { Package, ShoppingBag } from 'lucide-react';

const filtros = [
  { valor: 'TODOS', rotulo: 'Todos' },
  { valor: 'ANDAMENTO', rotulo: 'Em andamento' },
  { valor: 'AGUARDANDO_PAGAMENTO', rotulo: 'Aguardando pagamento' },
  { valor: 'ENTREGUE', rotulo: 'Entregues' },
  { valor: 'CANCELADO', rotulo: 'Cancelados' },
];

export function ContaPedidosPage() {
  const [filtro, setFiltro] = useState('TODOS');

  const { data: pedidos, isLoading } = useQuery({
    queryKey: ['conta-pedidos'],
    queryFn: () => contaApi.pedidos().then(r => r.data as any[]),
  });

  if (isLoading) return <Loading />;

  const lista = (pedidos || []).filter(p => {
    if (filtro === 'TODOS') return true;
    if (filtro === 'ANDAMENTO') return ['PAGO', 'EM_PRODUCAO', 'PRONTO'].includes(p.status);
    return p.status === filtro;
  });

  return (
    <div className="space-y-6 animate-fade-up">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold text-ink-950 tracking-tight">Meus pedidos</h1>
          <p className="text-sm text-ink-500 mt-1">Acompanhe o status e pague os pedidos pendentes.</p>
        </div>
        <Link to="/loja" className="btn-primary !px-5 shrink-0">
          <ShoppingBag className="w-4 h-4" /> Novo pedido
        </Link>
      </div>

      {/* Filtros */}
      <div className="flex gap-2 overflow-x-auto pb-1">
        {filtros.map(f => (
          <button
            key={f.valor}
            onClick={() => setFiltro(f.valor)}
            className={`px-4 py-2 rounded-full text-[13px] font-semibold whitespace-nowrap transition-colors ${
              filtro === f.valor
                ? 'bg-brand-600 text-white shadow-sm'
                : 'bg-white text-ink-500 border border-ink-200 hover:border-ink-300 hover:text-ink-800'
            }`}
          >
            {f.rotulo}
          </button>
        ))}
      </div>

      {lista.length === 0 ? (
        <div className="card">
          <EmptyState
            icon={Package}
            titulo="Nenhum pedido encontrado"
            descricao={filtro === 'TODOS'
              ? 'Você ainda não fez nenhum pedido. Visite a loja para começar.'
              : 'Não há pedidos neste filtro.'}
          />
        </div>
      ) : (
        <div className="space-y-3">
          {lista.map(p => <CartaoPedido key={p.id} pedido={p} />)}
        </div>
      )}
    </div>
  );
}
